import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { MapPin } from "lucide-react";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function CityBreakdown({ rows }) {
  const [q, setQ] = useState("");
  const shown = rows.filter((r) => `${r.district} ${r.state}`.toLowerCase().includes(q.toLowerCase()));
  const sum = (k) => shown.reduce((a, r) => a + r[k], 0);

  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden" data-testid="analytics-city-breakdown">
      <div className="px-5 py-3.5 border-b border-border flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-primary" /> <h3 className="text-base font-semibold">City-wise Overview</h3>
        </div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search city or state…" className="h-8 w-56" data-testid="city-breakdown-search" />
      </div>
      <div className="overflow-x-auto max-h-[420px]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>City / Area</TableHead><TableHead>State</TableHead>
              <TableHead className="text-right">Total</TableHead><TableHead className="text-right">Contracted</TableHead>
              <TableHead className="text-right">Non-Contracted</TableHead><TableHead className="text-right">Expiring (30d)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {shown.length === 0 ? (
              <TableRow><TableCell colSpan={6} className="h-24 text-center text-sm text-muted-foreground" data-testid="city-breakdown-empty">No corporates found.</TableCell></TableRow>
            ) : shown.map((r) => (
              <TableRow key={`${r.state}-${r.district}`} data-testid={`city-row-${slug(r.district)}-${slug(r.state)}`}>
                <TableCell className="font-medium">{r.district}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{r.state}</TableCell>
                <TableCell className="text-right font-mono font-semibold">{r.total}</TableCell>
                <TableCell className="text-right font-mono text-blue-700">{r.contracted}</TableCell>
                <TableCell className="text-right font-mono text-slate-600">{r.non_contracted}</TableCell>
                <TableCell className={`text-right font-mono ${r.expiring ? "text-orange-700 font-semibold" : "text-muted-foreground"}`}>{r.expiring}</TableCell>
              </TableRow>
            ))}
            {shown.length > 1 && (
              <TableRow className="bg-muted/40 font-semibold" data-testid="city-breakdown-total-row">
                <TableCell colSpan={2}>Total</TableCell>
                <TableCell className="text-right font-mono">{sum("total")}</TableCell>
                <TableCell className="text-right font-mono">{sum("contracted")}</TableCell>
                <TableCell className="text-right font-mono">{sum("non_contracted")}</TableCell>
                <TableCell className="text-right font-mono">{sum("expiring")}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
